import { CurrencyDollarIcon } from '@heroicons/react/24/outline';

import { useAppDispatch } from 'src/app/store/hooks';

import { onPriceSummaryModalOpen } from '../pricing.slice';

export function PriceSummaryModalButton({ tripId }: { tripId: string }) {
  const dispatch = useAppDispatch();

  return (
    <CurrencyDollarIcon
      data-testid="price-summary-modal-button"
      className="h-6 w-6 hover:cursor-pointer"
      onClick={() => dispatch(onPriceSummaryModalOpen(tripId))}
    />
  );
}
